export const SET_VISIBILITY = 'SET_VISIBILITY';
export const SET_FILEDOWNLOADING = 'SET_FILEDOWNLOADING';
export const SET_DOWNLOADING_VISIBILITY = 'SET_DOWNLOADING_VISIBILITY';
